import React from 'react';
import styled from 'styled-components';

import { useTranslation } from '@crehana/i18n';

import getStaticUrl from 'Jsx/Utils/getStaticUrl';

const Img = styled.img`
  width: 53px;
  height: 40px;

  ${({ theme }) => theme.breakpoints.up('md')} {
    width: 84px;
    height: 63px;
  }
`;

const GuaranteeShort: React.FC<{
  text?: string;
  className?: string;
  isDark?: boolean;
}> = ({ text, className, isDark }) => {
  const { t } = useTranslation();

  return (
    <div className={`flex items-center ${className}`}>
      <Img
        src={getStaticUrl(
          isDark
            ? 'img/checkout/guarante-dark.png'
            : 'img/checkout/garantia.png',
        )}
        width="84px"
        height="63px"
        alt="Garantía"
        className="inline-block mr-12"
      />
      <p className="font-body4">{text || t('MS_GUARANTEE_SHORT')}</p>
    </div>
  );
};

export default GuaranteeShort;
